import { render, staticRenderFns } from "./DocumentsTypeForm.vue?vue&type=template&id=04972ddb&"
import script from "./DocumentsTypeForm.vue?vue&type=script&lang=js&"
export * from "./DocumentsTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports